import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SignUpComponent.css";

const SignUpComponent = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    org_name: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    application_type: "insurance",
  });

  const [isFormValid, setIsFormValid] = useState(false);

  // Validate form (excluding email and phoneNumber)
  useEffect(() => {
    const { org_name, firstName, lastName, application_type } = formData;
    const valid =
      org_name.trim() &&
      firstName.trim() &&
      lastName.trim() &&
      application_type.trim();
    setIsFormValid(!!valid);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/mcv/add_tenant", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if ((data.status === "SUCCESS") && (data.DATA.status === "success" && data.DATA.val === 2)) {
        navigate("/mcv/proceed");
      } else if ((data.status === "SUCCESS") && (data.DATA.status === "success" && data.DATA.val === 1)) {
        navigate("/mcv/admin-approval");
      } else if ((data.status === "FAILED") && (data.DATA.status === "failed" && data.DATA.val === 0)) {
        navigate("/mcv/access-denied");
      }
    } catch (error) {
      console.error("Error during signup:", error);
      alert("An error occurred during signup.");
      navigate("/mcv/access-denied");
    }
  };

  const handleCancel = () => {
    navigate("/mcv/login");
  };

  return (
    <div className="signup-container">
      <div className="signup-content">
        <div className="signup-component-header">Sign Up</div>
        <form onSubmit={handleSubmit}>
          <div className="floating-label-input-signup">
            <input
              type="text"
              name="org_name"
              value={formData.org_name}
              onChange={handleChange}
              placeholder=" "
              className="input-tag-width"
            />
            <label>Organization Name*</label>
          </div>

          <div className="floating-label-input-signup">
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder=" "
              className="input-tag-width"
            />
            <label>First Name*</label>
          </div>

          <div className="floating-label-input-signup">
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder=" "
              className="input-tag-width"
            />
            <label>Last Name*</label>
          </div>

          <div className="floating-label-input-signup">
            <select
              name="application_type"
              value={formData.application_type}
              onChange={handleChange}
              className="select-tag-width"
            >
              <option value="insurance">Insurance</option>
              <option value="mutual_fund">Mutual Fund</option>
            </select>
            <label>Organization Sector*</label>
          </div>

          <div className="button-container">
            <button type="button" className="cancel-button" onClick={handleCancel}>
              Cancel
            </button>
            <button
              type="submit"
              className="signup-button"
              disabled={!isFormValid}
              style={{
                cursor: isFormValid ? 'pointer' : 'not-allowed',
                opacity: isFormValid ? 1 : 0.6
              }}
            >
              Sign Up
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUpComponent;
